import type { ClientUiPublic } from '../api/platformConfig'
import {
  type ComicProjectSettings,
  normalizeComicProjectSettings,
} from './comicProjectSettings'
import type { ComicEpisode, ComicProject } from './comicTypes'

export type ComicEpisodeSettings = ComicProjectSettings

export function normalizeEpisodeSettings(
  raw: unknown,
  clientUi: ClientUiPublic,
): ComicEpisodeSettings {
  return normalizeComicProjectSettings(raw, clientUi)
}

export function getEpisodeSettings(
  project: ComicProject,
  _episode: ComicEpisode,
  clientUi: ClientUiPublic,
): ComicEpisodeSettings {
  return normalizeEpisodeSettings(project.settings, clientUi)
}

export function mirrorPrimaryEpisodeSettings(project: ComicProject, clientUi: ClientUiPublic): ComicProject {
  const settings = normalizeEpisodeSettings(project.settings, clientUi)
  return {
    ...project,
    settings,
    episodes: project.episodes,
  }
}

export function episodeHasGeneratedImages(episode: ComicEpisode): boolean {
  return episode.panels.some((p) => p.candidates.length > 0 || Boolean(p.imageUrl))
}
